import './Tabs.scss';
import { defineComponent, h, PropType, VNode } from 'vue';

type Tab = {
    id: string;
    text: string;
    slot: () => VNode | VNode[];
}

export default defineComponent({
    props: {
        tabs: {
            required: true,
            type: Array as PropType<Array<Tab>>,
        },

        tab: {
            required: false,
            type: String as PropType<string>,
        },
    },

    data() {
        return {
            current_tab: this.tab || this.tabs[0]!.id,
        };
    },

    emits: {
        'update:tab': (x: string) => true,
    },

    watch: {
        current_tab(value: typeof this.current_tab) {
            if (this.tab && value !== this.tab)
                this.$emit('update:tab', value);
        },

        tab(value: typeof this.tab) {
            if (value && value !== this.current_tab)
                this.current_tab = value;
        },
    },

    mounted() {
        if (this.tabs.length === 1)
            this.$emit('update:tab', this.tabs[0]!.id);
    },

    render() {
        const header = this.tabs.length > 1
            ? h('ul', {
                class: 'nav nav-fill',
                role: 'tablist',
            }, this.tabs.map(x => h('li', { class: 'nav-item' }, h('a', {
                class: { 'nav-link': true, active: x.id === this.current_tab },
                id: x.id,
                'data-toggle': 'tab',
                href: '#',
                onClick: () => this.current_tab = x.id,
            }, x.text))))
            : '';

        const body = h('div', { class: 'tab-content' },
            this.tabs.map(x => h('section', {
                class: {
                    'tab-pane': true,
                    active: this.current_tab === x.id,
                },
                id: 'tab-' + x.id,
                role: 'tabpanel',
            }, x.slot()))
        );

        return h('div', { class: 'tabs-container' }, [ header, body ]);
    }
});
